import { currentPathNameSelector } from '../../../redux/app/selectors';
import { userProfileDataSelector } from '../../../redux/user/selectors';

export default (state) => ({
  currentPathName: currentPathNameSelector(state),
  userProfile: userProfileDataSelector(state),
});
